import {useContext, useEffect, useState} from "react";
import {gql, useQuery} from "@apollo/client";
import moment from "moment";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";
import {UserContext} from "../store/providers/UserProvider";

const QUERY = gql`query getInfoMessage($locale: String!, $id: String!) {
    infoMessageCollection(locale: $locale, limit: 3, where: {id: $id}, order: priority_ASC) {
        items {
            name
            id
            infoMessageTitle
            infoMessageText{
                json
                links {
                    assets {
                        block {
                            sys {id}
                            url
                            description
                        }
                    }
                }
            }
            footnote
            visibleTo
            visibleFrom
            includeCountries
            userCountryCollection {
                items {
                    ... on Country {
                        countryCode
                    }
                }
            }
            visibleForUserRoles
            priority
            ctaLinksCollection {
                items {
                    ...on Button {
                        type
                        label
                        url
                    }
                }
            }
        }
    }
}`;

export const useInfoMessages = (id) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {
        variables: {id, locale: localeUppercase},
        fetchPolicy: "no-cache",
        errorPolicy: "all"
    });
    const allInfoMessages = data?.infoMessageCollection?.items;
    const user = useContext(UserContext)?.[0]?.user;
    const [infoMessages, setInfoMessages] = useState([]);

    if (error?.message) {
        logger(error?.message, "error", "useInfoMessages", error?.stack);
    }

    useEffect(() => {
        if (allInfoMessages?.length) {
            const tmpInfoMessages = [];
            for (let i = 0; i < allInfoMessages.length; i++) {
                const infoMessage = Object.assign({}, allInfoMessages[i]);
                const isFromInRange = moment().isSameOrAfter(infoMessage.visibleFrom, "day");
                const isToInRange = moment().isSameOrBefore(infoMessage.visibleTo, "day");
                let isFromCountry = true;
                if(infoMessage.userCountryCollection?.items?.length && user?.country) {
                    if (!infoMessage.includeCountries) {
                        isFromCountry = !infoMessage.userCountryCollection?.items?.some(country => country.countryCode === user.country.toUpperCase());
                    } else {
                        isFromCountry = infoMessage.userCountryCollection?.items?.some(country => country.countryCode === user.country.toUpperCase());
                    }
                }
                if(isFromInRange && isToInRange && isFromCountry) {
                    tmpInfoMessages.push(infoMessage);
                }
            }

            if(tmpInfoMessages.length) {
                setInfoMessages(tmpInfoMessages);
            }
        }
    }, [allInfoMessages, user?.country]);

    return {
        allInfoMessages,
        loading,
        error,
        infoMessages
    };
};
